module.exports = __webpack_public_path__ + "static/media/Chatbot.bf72dc3c.jpg";